import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export const GetRosters = () => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `shift`);
};
export const AddRoster = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `shift/add`, obj, {
    headers,
  });
};
export const ShiftElementUpdate = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `shift/update`, obj, {
    headers,
  });
};
export const ShiftElementDelete = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `shift/delete`, obj, {
    headers,
  });
};
export default class Roster {}
